import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../lib/api'
import { CredentialingBadge } from '../../components/ui'
import type { AdminProviderRow } from '../../lib/types'

export default function AdminProviders() {
  const [providers, setProviders] = useState<AdminProviderRow[]>([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    api('/admin/providers?limit=200').then((rows) => { setProviders(rows); setLoading(false) })
  }, [])

  const filtered = providers.filter((p) => {
    if (!search.trim()) return true
    const q = search.trim().toLowerCase()
    return p.name.toLowerCase().includes(q) || (p.organization_name || '').toLowerCase().includes(q)
  })

  if (loading) return <div className="page-loading">Loading providers…</div>

  return (
    <div>
      <div className="page-head">
        <h1>Providers</h1>
        <div className="ph-sub">Cross-organization provider roster, credentialing, and seat status.</div>
      </div>

      <input
        className="inp"
        style={{ maxWidth: 280, marginBottom: 14 }}
        placeholder="Search by name or organization…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th><th>Organization</th><th>Credentialing</th><th>Profile</th><th>Seat</th>
              <th>Activated</th><th>First session</th><th>First patient</th><th>Matches</th><th>Session 4s</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((p) => (
              <tr key={p.id} onClick={() => navigate(`/admin/providers/${p.id}`)} style={{ cursor: 'pointer' }}>
                <td>{p.name}</td>
                <td>{p.organization_name || '—'}</td>
                <td><CredentialingBadge status={p.credentialing_status} /></td>
                <td><span className={`badge ${p.profile_completed_at ? 'badge-green' : 'badge-grey'}`}>{p.profile_completed_at ? 'Complete' : 'Incomplete'}</span></td>
                <td><span className={`badge ${p.seat_status === 'active' ? 'badge-green' : 'badge-grey'}`}>{p.seat_status}</span></td>
                <td className="muted">{p.seat_activated_at ? new Date(p.seat_activated_at).toLocaleDateString() : '—'}</td>
                <td className="muted">{p.first_attended_session_at ? new Date(p.first_attended_session_at).toLocaleDateString() : '—'}</td>
                <td className="muted">{p.first_patient_name || '—'}</td>
                <td>{p.match_count}</td>
                <td>{p.session_4_completions}</td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={10} className="muted">{providers.length === 0 ? 'No providers yet.' : 'No providers match this search.'}</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  )
}
